import React, { useRef } from 'react';
import { DetailedHTMLProps, useEffect } from 'react';
import { useEventCallback } from 'src/hooks';

export interface ClickOutsideProps
  extends DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    React.PropsWithChildren {
  // When clicked outside.
  onClickOutside: (event: MouseEvent) => any;

  // Indicates whether the outside click handler is active.
  isActive: boolean;
}

export const ClickOutside = React.memo((props: ClickOutsideProps) => {
  const { children, isActive, onClickOutside, ...other } = props;

  const container = useRef<HTMLDivElement>();

  const initContainer = useEventCallback((div: HTMLDivElement) => {
    container.current = div;
  });

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      if (container.current && !container.current.contains(event.target as any)) {
        onClickOutside(event);
      }
    };

    if (isActive) {
      document.addEventListener('click', onClick, true);

      return () => {
        document.removeEventListener('click', onClick, true);
      };
    }

    return undefined;
  }, [isActive, onClickOutside]);

  return (
    <div {...other} ref={initContainer}>
      {children}
    </div>
  );
});
